import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase";
import "./Work.css";

function Work() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const carouselRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDocs(collection(db, "categories"));
      const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCategories(data.slice(0, 12)); // show up to 12 categories
    };
    fetchData();
  }, []);

  const scroll = (direction = 1) => {
    if (!carouselRef.current) return;
    const el = carouselRef.current;
    const offset = el.clientWidth * 0.6 * direction; // scroll by 60% of view
    el.scrollBy({ left: offset, behavior: "smooth" });
  };

  return (
    <section className="work-section">
      <div className="section-header">
        <h1>Interior Design Categories: From Concept to Completion</h1>
        <p>Explore our comprehensive interior design categories, covering every aspect of your home from concept to completion. Our designers work meticulously to bring your vision to life.</p>
      </div>

      <div className="carousel-wrap">
        <button
          className="carousel-btn left"
          aria-label="Scroll left"
          onClick={() => scroll(-1)}
        >
          ‹
        </button>

        <div className="service-carousel" ref={carouselRef}>
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="service-card"
              onClick={() => navigate(`/category/${cat.slug}`)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate(`/category/${cat.slug}`);
              }}
            >
              <div className="service-image">
                <img src={cat.coverImage} alt={cat.name} />
              </div>
              <div className="service-name">{cat.name}</div>
            </div>
          ))}
        </div>

        <button
          className="carousel-btn right"
          aria-label="Scroll right"
          onClick={() => scroll(1)}
        >
          ›
        </button>
      </div>
    </section>
  );
}

export default Work;